import React, { FC, useEffect } from 'react';
import { MessageType, useSendPostMessage } from '../hooks/useWindowPostMessage';

type ParentPostMessagePageProps = {
  messageType: MessageType;
  text?: string;
};

export const ParentPostMessagePage: FC<ParentPostMessagePageProps> = ({ messageType, text }) => {
  const { sendPostMessage } = useSendPostMessage();

  useEffect(() => {
    sendPostMessage(messageType, () => window.close());
  }, [sendPostMessage, messageType]);

  return <div>{text ?? 'Redirecting...'}</div>;
};
